import requestor from "../../requestor";

export default class AccountApi {
  common = () => requestor.get("/project/user_common");
  info = () => requestor.get("/account/info");
  menu = () => requestor.get("/account/get_menu");
  setDefaultProject = (id) => requestor.put("/project/set_default", { id: id });
  transactions = () => requestor.get("/account/finance_list");
  orderReport = () => requestor.get("/account/generate_order_report");
  financeReport = () => requestor.get("/account/finance_report");
  userBalances = () => requestor.get("/account/user_balance_list");
  createConsultation = (form) => requestor.post("/account/consultation_create", form);

  payout = {
    all: (page = 1) => requestor.get("/account/payout_request_all", { page: page }),
    create: (balanceId, amount, feeFromBalance) =>
      requestor.post("/account/payout_request_create", {
        balance_id: balanceId,
        amount: amount,
        fee_from_balance: feeFromBalance,
      }),
    moneyTransfer: (nick_name, amount) =>
      requestor.get("/account/money_transfer", {
        nick_name: nick_name,
        amount: amount,
      }),
    saveReceipt: (request_id, link) =>
      requestor.get("/account/save_payout_request_receipt", {
        request_id: request_id,
        link: link,
      }),
  };

  paymentType = {
    all: () => requestor.get("/account/payment_type_all"),
  };

  profile = {
    get: () => requestor.get("/account/profile_get"),
    save: ({ first_name, last_name, second_name, nick_name, email, phone, description }) =>
      requestor.patch("/account/profile_save", {
        UserPersonal: {
          first_name: first_name,
          last_name: last_name,
          second_name: second_name,
          nick_name: nick_name,
          email: email,
          phone: phone,
          description: description,
        },
      }),
    phoneVerifyRequest: () => requestor.post("/account/phone_verify_request"),
    phoneVerifySubmit: (code) => requestor.put("/account/phone_verify_submit", { code: code }),
  };

  changePassword = ({new_password, repeat_new_password}) =>
    requestor.put("/account/change_password", {
      Password: { new_password: new_password, repeat_new_password: repeat_new_password },
    });

  telegram = {
    getBindLink: () => requestor.get("/account/telegram_bind_link"),
    unbind: () => requestor.patch("/account/telegram_unbind"),
  };

  vk = {
    bind: () => requestor.put("/account/bind_vk"),
    unbind: () => requestor.delete("/account/unbind_vk"),
  };

  alert = {
    read: (id) => requestor.get("/account/read_alert", { id: id }),
    setNotificationNpdState: (id, stateId) => requestor.patch("/account/set-notification-npd-state", { id: id, state_id: stateId}),
  };
}
